import { isProduction } from 'shared/lib';

import type { IInitialEvent } from '../types';

import { formatEventLabelWithQuery } from './formatEventLabelWithQuery';
import { formatValue } from './formatValue';

export const sendEventToGA = (event: IInitialEvent, currentWindow = window) => {
  const data = {
    event: event.event,
    eventCategory: event.eventCategory || 'Кредиты',
    eventAction: formatValue(event.eventAction) || '',
    eventLabel: formatEventLabelWithQuery(formatValue(event.eventLabel), currentWindow),
    eventValue: event.eventValue,
  };

  if (isProduction()) {
    if (typeof currentWindow.sravniDataLayer === 'undefined') {
      currentWindow.sravniDataLayer = [];
    }

    if (event.eventCallback && currentWindow.sravniDataLayer.push === Array.prototype.push) {
      event.eventCallback();
    }

    currentWindow.sravniDataLayer.push(data);
  } else {
    // eslint-disable-next-line no-console
    console.groupCollapsed(`Analytics Event: ${formatValue(event.eventAction)}`);
    // eslint-disable-next-line no-console
    console.table(data);
    // eslint-disable-next-line no-console
    console.groupEnd();
  }
};
